import React from 'react';
import { OPTIONS } from 'src/pages/MainEmbedOptions/constatnts/mainEmbedOptionsOptions';
import EmbedPage from 'src/shared/components/EmbedPage/EmbedPage';

export default function MainEmbedOptions({ productSelected }) {
  return <EmbedPage options={OPTIONS} productSelected={productSelected}></EmbedPage>;
}
